let view = null;

export default {
	namespace: 'template-service-single',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: ServiceView } = await import(
			/* webpackChunkName: "service-view" */ '../../templates/ServiceView'
		);
		view = new ServiceView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
